import { useGetRequest } from "@ch/api/useGetRequest";
import { ReferralControllerService } from "@ch/generated";
import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";
import moment from "moment";
import { useMemo } from "react";

const useGetReferrals = () => {
  const user = useAppSelector((state) => state.user?.currentUser);
  const hasSubscription = user?.subscriptions?.find((item) =>
    moment(item.endDate).isAfter(moment(), "day"),
  );

  const { data, loading } = useGetRequest({
    service: ReferralControllerService.referralControllerFind,
    tag: "ReferralControllerService",
    enabled: !!hasSubscription,
    payload: {
      page: 1,
      filter: {
        limit: 1234,
        where: {
          userId: user?.id,
          referralType: "internal",
        },
      },
    },
  });

  const referralCoaches = useMemo(
    () => (data?.data ?? [])?.map((item) => item.receiverCoach!),
    [data?.data],
  );

  return {
    referralCoaches,
    loading,
  };
};

export default useGetReferrals;
